import { render, staticRenderFns } from "./SurveyJsForm.vue?vue&type=template&id=e5221680&"
import script from "./SurveyJsForm.vue?vue&type=script&lang=js&"
export * from "./SurveyJsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports